<template>
  <div class="ant-upload-text">
    <h2 class="ant-upload-h2-text">
      <slot></slot>
    </h2>
  </div>
</template>